"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = shop;

var _ShopActionTypes = require("../constants/action-types/ShopActionTypes");

var types = _interopRequireWildcard(_ShopActionTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var initialState = {
  store: {
    fetching: false,
    products: [],
    error: null
  },
  selected: null
};

function shop() {
  var shop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case types.RETRIEVING_STORE:
      return setStoreLoading(shop);

    case types.GET_STORE_PRODUCTS_SUCCESS:
      return addProductsToState(shop, payload);

    case types.GET_STORE_PRODUCTS_FAILURE:
      return failedToRetrieveStore(shop, payload);

    default:
      return shop;
  }
}

var addProductsToState = function addProductsToState(shop, _ref2) {
  var products = _ref2.products,
      variantMap = _ref2.variantMap;
  return _extends({}, shop, {
    store: _extends({}, shop.store, {
      fetching: false,
      products: products,
      variantMap: variantMap
    })
  });
};

var setStoreLoading = function setStoreLoading(shop) {
  return _extends({}, shop, {
    store: _extends({}, shop.store, {
      fetching: true
    })
  });
};

var failedToRetrieveStore = function failedToRetrieveStore(shop, error) {
  return _extends({}, shop, {
    store: _extends({}, shop.store, {
      fetching: false,
      error: error
    })
  });
};